import { BellIcon } from './BellIcon';

/**
 * author: Google
 * id 45fea174-07db-11e4-bf19-842b2b6cfe1b
 * name bell
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bell.svg
 * tags
 * - Notification 
 * - Home Automation 
 * - Music 
 */
export const NotificationsIcon = BellIcon;
export default NotificationsIcon